import { alpha, Box, Modal, Radio, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import { DefaultButton, SuccessButton } from "..";
import { useEffect, useState } from "react";

export default function UserRoleModal({
    open,
    onClose,
    onFinish,
    user,
}) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 360,
        maxWidth: 450,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };
    const [role, setRole] = useState("guest");

    useEffect(() => {
        if (user) {
            setRole(user.role ?? "guest");
        }
    }, [user, open]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-user-role-title"
            aria-describedby="modal-user-role-description"
        >
            <Box sx={style}>
                <Typography id="modal-user-role-title"
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.semiBold,
                        fontSize: Constants.Styles.fontSize.lg,
                        lineHeight: Constants.Styles.lineHeight.lg,
                    }}
                >
                    Change Role
                </Typography>

                <Box>
                    <Typography
                        sx={{
                            fontWeight: Constants.Styles.fontWeight.normal,
                            fontSize: Constants.Styles.fontSize.sm,
                            lineHeight: Constants.Styles.lineHeight.sm,
                            marginBlock: "1.5rem 0.5rem",
                            color: Constants.Colors[currentMode].mutedForeground,
                        }}
                    >Select a new role for <b
                        style={{
                            color: Constants.Colors[currentMode].foreground,
                        }}>{user?.user_id}</b></Typography>

                </Box>
                <Stack
                    spacing={"0.75rem"}
                >
                    {Constants.Roles.map((r, index) => {
                        return (
                            <Stack
                                key={index}
                                direction={"column"}
                                spacing={"1.125rem"}
                                sx={{
                                    padding: "0.75rem 0.25rem",
                                    backgroundColor: alpha(Constants.Colors[currentMode].secondary, 0.3),
                                    borderRadius: `calc(${Constants.Styles.radius.base} * 1)`,
                                    border: `1px solid ${Constants.Colors[currentMode].border}`,
                                }}
                            >
                                <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    justifyContent={"start"}
                                    spacing={0}
                                >
                                    <Radio
                                        checked={role === r.value}
                                        onChange={() => {
                                            setRole(r.value);
                                        }}
                                        sx={{
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 20,
                                            },
                                        }}
                                    />
                                    <Typography
                                    sx={{
                                        fontWeight: Constants.Styles.fontWeight.medium,
                                        fontSize: Constants.Styles.fontSize.sm,
                                        lineHeight: Constants.Styles.lineHeight.sm,
                                    }}
                                    >{r.label}</Typography>
                                    <Typography
                                    sx={{
                                        fontWeight: Constants.Styles.fontWeight.normal,
                                        fontSize: Constants.Styles.fontSize.xs,
                                        lineHeight: Constants.Styles.lineHeight.xs,
                                        color: Constants.Colors[currentMode].mutedForeground,
                                        pl: 1,
                                    }}
                                    >{r.des}</Typography>
                                </Stack>
                            </Stack>
                        );
                    })}
                </Stack>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"end"}
                    sx={{
                        mt: "1.5rem",
                    }}
                    spacing={2}
                >
                    <DefaultButton
                        text={"Cancel"}
                        size="medium"
                        onClick={() => {
                            onClose();
                        }}
                        sx={{
                            width: 60,
                        }}
                    />
                    <SuccessButton
                        text={"Update Role"}
                        size="medium"
                        onClick={() => {
                            onFinish({
                                role: role,
                                user: user,
                            });
                        }}
                        sx={{
                            width: 160,
                        }}
                    />
                </Stack>
            </Box>
        </Modal>
    );
}